import React, { Fragment } from 'react';
import { Form, InputNumber } from 'antd';

const PassengerCapacity = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">Пассажировместимость:</span>
      <Form.Item>
        {getFieldDecorator('passengerCapacity', {
          rules: [{
            required: true,
            message: "Поле, обязательно для заполнения"
          }]
        })(
          <InputNumber
            min={2}
            max={150}
            maxLength={3}
            placeholder="Укажите"
            className="smallInput"
            disabled={disabled}
          />
        )}
      </Form.Item>
    </Fragment>
  );
};

export default PassengerCapacity;
